import { constructEnum } from '@/lib/enum';

export default constructEnum('ThumbnailShape', {
  SQUARE: 0,
  CIRCLE: 10
});
